import { useState } from "react";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { submitLead } from "@/lib/api";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function LeadCapture({ result, onSaved }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  if (!result?.assessment_id) return null;

  if (result.lead_email) {
    return (
      <div className="mt-8 flex items-start gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 px-5 py-4 text-sm text-emerald-800" data-testid="lead-capture-done">
        <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" />
        <span>Thanks — we'll follow up at <strong>{result.lead_email}</strong> if we can help with your PNP plan.</span>
      </div>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email)) { toast.error("Please enter a valid email address"); return; }
    setBusy(true);
    try {
      await submitLead(result.assessment_id, email.trim());
      onSaved(email.trim().toLowerCase());
      toast.success("Email saved — thank you");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not save your email. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:flex sm:items-center sm:justify-between sm:gap-6" data-testid="lead-capture">
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#FEF2F2] text-[#C8102E]"><Mail className="h-5 w-5" /></span>
        <div>
          <h3 className="font-heading text-base font-semibold text-slate-900">Want a follow-up on these results?</h3>
          <p className="mt-1 text-sm text-slate-600">Optional. Leave your email and we can reach out about your best PNP options. Nothing else about you is stored.</p>
        </div>
      </div>
      <form onSubmit={submit} className="mt-4 flex gap-2 sm:mt-0 sm:w-[22rem] sm:shrink-0">
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="lead-email-input"
          className="min-w-0 flex-1 rounded-md border border-slate-300 px-3 py-2.5 text-sm text-slate-800 placeholder:text-slate-400 focus:border-[#C8102E] focus:outline-none focus:ring-2 focus:ring-[#C8102E]/20" />
        <button type="submit" disabled={busy} data-testid="lead-submit-btn"
          className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-[#0F172A] px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#1E293B] disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Keep me posted
        </button>
      </form>
    </div>
  );
}
